export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_49-73d355b1e73a9fff5ded9da39c4acffd.jpg";